export default __webpack_public_path__ + "img/selects-016b3741.png";